import React from 'react';
import { TrackingState } from '~/helpers/store/connection/connection';
import { TAnswer } from '~/utils/airtable/types/types';

export type TCoord = {
  coords: string;
  height: string;
  width: string;
};
// getStatus pour unique réponse
export function getStatus(
  answer: TAnswer,
  _selectedAnswer: TAnswer | undefined
): 'good' | 'wrong' | 'warning' | 'neutral' {
  if (!_selectedAnswer) return 'neutral';

  if (_selectedAnswer.text === answer.text) {
    if (_selectedAnswer.isCorrect) return 'good';
    else return 'wrong';
  } else {
    if (answer.isCorrect) return 'good';
  }
  return 'neutral';
}

export function getStatusMultipleAnswers(
  answer: string,
  answers: TAnswer[],
  _selectedAnswers: string[] // text
): 'good' | 'wrong' | 'warning' | 'neutral' {
  if (_selectedAnswers.length === 0) return 'neutral';
  const _answer = answers.find((el) => el.text === answer);
  if (!_answer) return 'neutral';
  if (_answer.isCorrect) {
    if (_selectedAnswers.includes(_answer.text)) {
      return 'good';
    } else {
      return 'warning';
    }
  } else {
    if (_selectedAnswers.includes(_answer.text)) return 'wrong';
  }
  return 'neutral';
}

export function getStatusGrid(
  answer: string,
  selectedAnswers: string[],
  correctAnswers: string[]
): 'good' | 'wrong' | 'warning' | 'neutral' {
  if (selectedAnswers.length === 0) return 'neutral';

  if (correctAnswers.includes(answer)) {
    if (selectedAnswers.includes(answer)) {
      return 'good';
    } else {
      return 'warning';
    }
  } else {
    if (selectedAnswers.includes(answer)) {
      return 'wrong';
    } else {
      return 'neutral';
    }
  }
}

export function getStatusQcm(
  answer: TAnswer,
  selectedAnswers: TAnswer[],
  correctAnswers: TAnswer[]
): 'good' | 'wrong' | 'warning' | 'neutral' {
  if (selectedAnswers.length === 0) return 'neutral';

  //
  if (correctAnswers.findIndex((el) => el.text === answer.text) !== -1) {
    if (selectedAnswers.findIndex((el) => el.text === answer.text) !== -1) {
      return 'good';
    } else {
      return 'warning';
    }
  } else {
    if (selectedAnswers.findIndex((el) => el.text === answer.text) !== -1) {
      return 'wrong';
    } else {
      return 'neutral';
    }
  }
}

export function parseStringToCoord(str: string): TCoord {
  const parts = str.split(';');

  const result = {
    coords: parts[0],
    height: parts[1],
    width: parts[2],
  };

  return result;
}

export const parseTextToJSX = (text: string): JSX.Element => {
  const elements: (string | JSX.Element)[] = [];
  let lastIndex = 0;

  // Expression régulière pour trouver les balises spéciales et les <br />
  const regex = /<c(\d)>(.*?)<\/c\1>|<br\s*\/>/g;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    // Ajouter le texte avant la balise trouvée
    if (match.index > lastIndex) {
      elements.push(text.slice(lastIndex, match.index));
    }

    if (match[0].startsWith('<br')) {
      // Ajouter un élément <br />
      const _br: JSX.Element = <br key={lastIndex} />;
      elements.push(_br);
    } else {
      // Ajouter un élément <span> avec la classe appropriée
      const className = `c${match[1]}`;
      elements.push(
        <span key={lastIndex} className={className}>
          {match[2]}
        </span>
      );
    }

    // Mettre à jour lastIndex pour la prochaine itération
    lastIndex = regex.lastIndex;
  }

  // Ajouter le texte restant après la dernière balise trouvée
  if (lastIndex < text.length) {
    elements.push(text.slice(lastIndex));
  }

  // Diviser les éléments par les <br /> pour créer des <p> séparés
  const paragraphs: JSX.Element[] = [];
  let currentParagraph: (string | JSX.Element)[] = [];

  elements.forEach((element, index) => {
    if (React.isValidElement(element) && element.type === 'br') {
      paragraphs.push(<p key={`p-${index}`}>{currentParagraph}</p>);
      currentParagraph = [];
    } else {
      currentParagraph.push(element);
    }
  });

  // Ajouter le dernier paragraphe s'il y a des éléments restants
  if (currentParagraph.length > 0) {
    paragraphs.push(<p key={`p-${elements.length}`}>{currentParagraph}</p>);
  }

  return <>{paragraphs}</>;
};

export function changeActivityOrder(
  trackingThematiqueId: number,
  order: number,
  trackings: TrackingState[]
): TrackingState[] {
  const _trackings = [...trackings];
  const ind = _trackings.findIndex(
    (el) => el.trackingThematiqueId === trackingThematiqueId
  );
  if (ind !== -1) {
    _trackings[ind].activityOrder = order;
  }
  return _trackings;
}

export function getCurrentActivityOrderByTrackingId(
  trackingThematiqueId: number,
  trackings: TrackingState[]
): number | undefined {
  const item = trackings.find(
    (el) => el.trackingThematiqueId === trackingThematiqueId
  );
  return item ? item.activityOrder : undefined;
}

export function deleteTrackingByTrackingId(
  trackingThematiqueId: number | null,
  trackings: TrackingState[]
): TrackingState[] {
  const _trackings = [...trackings];
  if (!trackingThematiqueId) return _trackings;

  const ind = trackings.findIndex(
    (el) => el.trackingThematiqueId === trackingThematiqueId
  );
  if (ind !== -1) _trackings.splice(ind, 1);
  return _trackings;
}
